import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Speaker = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M3.333.672h9.333a1.669 1.669 0 0 1 1.666 1.666v12a1.669 1.669 0 0 1-1.666 1.667H3.333a1.669 1.669 0 0 1-1.667-1.667v-12A1.669 1.669 0 0 1 3.333.672Zm9.333 14.666a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1H3.333a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9.333Z" />
      <path d="M8 7.672a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 5.333a2.334 2.334 0 1 0 0-4.668 2.334 2.334 0 0 0 0 4.668ZM7.999 3.006a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333Zm0 2.666a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
      <path d="M8 9.672a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0 1.333a.334.334 0 1 0 0-.667.334.334 0 0 0 0 .667Z" />
    </svg>
  );
};

Speaker.category = 'product-category';

Speaker.displayName = 'Speaker';
